import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import useBillTrackerAlert from './useBillTrackerAlert';

const BillTrackerWidget = ({ legislationId }) => {
  const { isAuthenticated } = useAuth0();
  const { isBillTracked, getBillTrackerAlert, toggleBillTracker } = useBillTrackerAlert();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !legislationId) return;
    const source = new AbortController();
    getBillTrackerAlert({ source });
    return () => {
      source.abort('Bill tracker widget cancelled by the user.');
    };
  }, [isAuthenticated, legislationId]);

  const handleToggle = async () => {
    if (!isAuthenticated || !legislationId || isLoading) return;
    setIsLoading(true);
    const wasTracked = isBillTracked(legislationId);
    await toggleBillTracker({ id: legislationId });
    setIsLoading(false);
    createNotification('success', wasTracked ? 'Stopped tracking this Bill' : 'Now tracking this Bill');
  };

  return (
    <div className='mb-3 py-3 px-3 box-rounded box-outstanding-reports bg-white'>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h3 className='mb-0'>Bill tracker</h3>
        <button
          className='general-button outline-button main-light-text paragraph-p3 rounded-button px-3 bg-white'
          disabled={isLoading || !isAuthenticated || !legislationId}
          onClick={handleToggle}
        >
          {isBillTracked(legislationId) ? 'Active' : 'Paused'}
          <span className={`ml-2 toggle-button-${isBillTracked(legislationId) ? 'active' : 'inactive'}`}>
            <span className='toggle-button'></span>
          </span>
        </button>
      </div>
      <span className='paragraph-p2 text-main-blue-40'>Get alerts for updates to this Bill</span>
    </div>
  );
};

export default BillTrackerWidget;
